import { Configuration, PopupRequest } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || "";
// For multi-tenancy, use 'organizations' to allow any organizational account
// or 'common' to allow both organizational and personal Microsoft accounts
// We'll validate specific tenants after login
const authority = process.env.REACT_APP_AZURE_AUTHORITY || "https://login.microsoftonline.com/organizations";

// Get allowed tenant IDs from environment variable (comma-separated)
export const getAllowedTenantIds = (): string[] => {
  const allowedTenants = process.env.REACT_APP_ALLOWED_TENANT_IDS || "";
  return allowedTenants
    .split(",")
    .map(t => t.trim())
    .filter(t => t.length > 0);
};

// MSAL configuration for multi-tenancy
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false
  }
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read", "GroupMember.Read.All"]
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

/**
 * Validates if a tenant ID is in the allowed list
 * @param tenantId - The tenant ID to validate
 * @returns true if the tenant is allowed, false otherwise
 */
export const isTenantAllowed = (tenantId: string): boolean => {
  const allowedTenants = getAllowedTenantIds();
  // If no allowed tenants are configured, deny all (fail-safe)
  if (allowedTenants.length === 0) {
    console.warn("No allowed tenants configured. Please set REACT_APP_ALLOWED_TENANT_IDS environment variable.");
    return false;
  }
  return allowedTenants.includes(tenantId);
};

/**
 * Extracts tenant ID from an account object or token
 * @param account - MSAL account object
 * @returns tenant ID or null if not found
 */
export const getTenantIdFromAccount = (account: any): string | null => {
  return account?.tenantId || account?.idTokenClaims?.tid || null;
};

/**
 * Performs a local logout without calling Microsoft's logout endpoint
 * This prevents the account picker popup from appearing
 * @param instance - MSAL instance
 */
export const performLocalLogout = (instance: any) => {
  // Clear MSAL cache
  instance.clearCache();
  
  // Clear any application-specific local storage
  const SIGNED_OUT_KEY = 'reporting-central-signed-out';
  localStorage.setItem(SIGNED_OUT_KEY, 'true');
  
  // Clear token service refresh timer if it exists
  // (This will be handled by the component that uses tokenService)
  
  // Reload the page to reset application state
  window.location.href = window.location.origin;
}; 